import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const NAV = [
  { section:'Overview',       items:[{ path:'/',                label:'Dashboard',       icon:'◈' }] },
  { section:'CRM',            items:[{ path:'/clients',         label:'Clients',         icon:'◎' },
                                      { path:'/leads',           label:'Leads',           icon:'◐' }] },
  { section:'Work',           items:[{ path:'/projects',        label:'Projects',        icon:'▣' },
                                      { path:'/services',        label:'Services',        icon:'⚙' },
                                      { path:'/invoices',        label:'Invoices',        icon:'◧' }] },
  { section:'Operations',    items:[{ path:'/job-orders',     label:'Job Orders',      icon:'◉' },
                                      { path:'/renewals',        label:'Renewals',         icon:'↻' },
                                      { path:'/project-closures', label:'Project Closures',  icon:'✓' }] },
  { section:'Infrastructure', items:[{ path:'/servers',         label:'Servers',         icon:'▤' }] },
  { section:'Finance',        items:[{ path:'/expenses',        label:'Expenses',        icon:'◫' },
                                      { path:'/payroll',          label:'Payroll',          icon:'◈' },
                                      { path:'/takhier',          label:'Takhier',           icon:'◆' },
                                      { path:'/partnerships',     label:'Partnerships',      icon:'🤝' }] },
  { section:'CRM+',           items:[{ path:'/contracts',       label:'Contracts',        icon:'◧' }] },
  { section:'Products',       items:[{ path:'/subscriptions',   label:'Subscriptions',   icon:'◉' },
                                      { path:'/payment-gateways',label:'Payment Gateways',icon:'◈' }] },
,
  { section:'Admin', items:[{ path:'/users',        label:'Users',             icon:'◎' },
                             { path:'/roles',        label:'Roles & Permissions', icon:'◈' },
                             { path:'/company-docs', label:'Company Documents',   icon:'◧' }] },
];

const META = {
  '/':                { title:'Dashboard',        sub:'Overview of all operations' },
  '/clients':         { title:'Clients',          sub:'Manage client records' },
  '/leads':           { title:'Leads Pipeline',   sub:'Track and convert leads' },
  '/projects':        { title:'Projects',         sub:'Active project tracking' },
  '/job-orders':      { title:'Job Orders',       sub:'Manage job orders and assignments' },
  '/renewals':        { title:'Renewals',         sub:'Track client renewals and expiry dates' },
  '/project-closures':{ title:'Project Closures',  sub:'Project handover and closure documents' },
  '/services':        { title:'Services',         sub:'Manage service categories' },
  '/invoices':        { title:'Invoices',         sub:'Billing and payments' },
  '/servers':         { title:'Servers',          sub:'Server contracts and expiry alerts' },
  '/expenses':        { title:'Expenses',         sub:'Monthly expenses and receipts' },
  '/payroll':         { title:'Payroll',          sub:'Employee salaries and payroll management' },
  '/contracts':       { title:'Contracts',        sub:'Client contracts and documents' },
  '/users':           { title:'Users',            sub:'Manage system users' },
  '/roles':           { title:'Roles & Permissions', sub:'Define role-based access control' },
  '/company-docs':    { title:'Company Documents',  sub:'Store and manage company documents' },
  '/subscriptions':   { title:'Subscriptions',    sub:'Website subscription plans' },
  '/payment-gateways':{ title:'Payment Gateways', sub:'Manage client payment gateway accounts' },
};

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const meta = META[pathname] || { title:'Teknulugy', sub:'' };
  const initials = user?.name?.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase()||'TK';
  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="logo-area">
          <img src="/logo.jpg" alt="Teknulugy" style={{width:42,height:42,borderRadius:10,objectFit:'cover',flexShrink:0,boxShadow:'0 2px 8px rgba(0,179,104,0.3)'}}/>
          <div><img src="/logo.svg" alt="Teknulugy" style={{height:28,width:"auto",display:"block",marginBottom:2}}/><div className="logo-tag">IT Services CRM</div></div>
        </div>
        <nav>
          {NAV.map(({section,items})=>(
            <div key={section}>
              <div className="nav-section">{section}</div>
              {items.map(({path,label,icon})=>(
                <div key={path} className={"nav-link"+(pathname===path?" active":"")} onClick={()=>navigate(path)}>
                  <span className="nav-icon">{icon}</span><span>{label}</span>
                </div>
              ))}
            </div>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="user-pill" onClick={logout} title="Logout">
            <div className="user-av">{initials}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:12,fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{user?.name}</div>
              <div style={{fontSize:10,color:'var(--muted)'}}>{user?.role}</div>
            </div>
            <span style={{fontSize:11,color:'var(--muted)'}}>↩</span>
          </div>
        </div>
      </aside>
      <div className="main">
        <header className="topbar">
          <div><div className="page-heading">{meta.title}</div><div className="page-sub">{meta.sub}</div></div>
          <div style={{display:'flex',alignItems:'center',gap:12}}>
            <span style={{fontSize:12,color:'var(--muted)'}}>{new Date().toLocaleDateString('en-KW',{dateStyle:'medium'})}</span>
            <div style={{width:8,height:8,borderRadius:'50%',background:'var(--green)'}}/>
          </div>
        </header>
        <div className="content">{children}</div>
      </div>
    </div>
  );
}
